import { ReferralTemplate } from "modules/ClientAccount/components/ReferralLinkWidget/ReferralTemplate"
import style from "modules/ClientAccount/components/ReferralLinkWidget/ReferralB2b/style.module.scss"

export function ReferralB2b() {
    return (
        <ReferralTemplate
            title={
                <span className={style.title}>
                    Подарите 3&nbsp;сессии со&nbsp;скидкой&nbsp;30%{" "}
                </span>
            }
            details={
                <>
                    Пригласите друга и&nbsp;он&nbsp;получит скидку&nbsp;30% на&nbsp;первые
                    3&nbsp;сессии.
                </>
            }
        />
    )
}
